import { createStore } from "owa-satcheljs";
import type { ManageCategoriesEnabledCalendarsForDelegate } from "./schema/ManageCategoriesEnabledCalendarsForDelegate";
import type { CalendarsUnionType } from "owa-graph-schema";

export const getStore: () => ManageCategoriesEnabledCalendarsForDelegate = createStore<ManageCategoriesEnabledCalendarsForDelegate>("manageCategoriesEnabledCalendarsForDelegate", { eligibleCalendars: new Map<string, CalendarsUnionType>() });
